import { useRouter } from "next/router";
import Link from "next/link";
import Meta from "../components/Meta";
import StructuredData from "../components/StructuredData";
import HeroSection from "../components/HeroSection";
import content from "../content/palvelumme";
import useScrollToHash from "../hooks/useScrollToHash";
import RichText from "../components/RichText";
import Icon from "../components/Icon";
import PreviewBanner from "../components/PreviewBanner";
import { getCompanyInfo } from "../lib/queries/getCompanyInfo";
import { getPageContent } from "../lib/queries/getPageContent";
import { getServices } from "../lib/queries/getServices";

function slugify(str) {
  return str
    .toLowerCase()
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/å/g, "a")
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export default function Palvelumme({
  services,
  companyInfo,
  pageContent,
  preview,
}) {
  const router = useRouter();
  useScrollToHash({ mobileOffset: 90, desktopOffset: 120 });
  console.log(services);

  const handleSmoothScroll = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    history.pushState(null, null, `#${id}`);
  };

  return (
    <>
      <Meta title={content.meta.title} description={content.meta.description} />
      <StructuredData />
      <div id="content">
        {preview && <PreviewBanner />}
        <HeroSection content={pageContent.hero} />
        <div className="page-content page-width page-section">
          <div className="flex flex-col md:flex-row md:gap-12">
            {/* Sticky anchor nav */}
            <aside className="w-full md:w-1/4 mb-8 md:mb-0 md:sticky top-24 self-start p-4 bg-brand-secondary">
              <ul className="space-y-2 font-medium">
                {services.map((service) => (
                  <li key={service._id}>
                    <Link
                      href={`#${slugify(service.title)}`}
                      scroll={false}
                      className="hover:underline font-semibold"
                      onClick={(e) =>
                        handleSmoothScroll(e, slugify(service.title))
                      }
                    >
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </aside>

            {/* Service sections */}
            <section className="md:w-3/4 space-y-12">
              <RichText value={pageContent.introText} />
              {services.map((service) => (
                <div
                  key={service._id}
                  id={slugify(service.title)}
                  className="scroll-mt-24"
                >
                  <h2 className="text-2xl font-bold mb-2">{service.title}</h2>
                  <div className="text-gray-700 leading-relaxed mb-4">
                    <RichText value={service.content} className="rich-text" />
                  </div>
                  {service.pricing?.title && (
                    <Link
                      href={`/hinnasto#${slugify(service.pricing.title)}`}
                      className="text-brand-primary font-medium hover:underline"
                    >
                      <span className="flex gap-1 items-center">
                        <span className="font-semibold">
                          {content.seePrices}
                        </span>
                        <Icon name="arrowRight" size="small" />
                      </span>
                    </Link>
                  )}
                </div>
              ))}
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps({ preview = false }) {
  const [services, companyInfo, pageContent] = await Promise.all([
    getServices(preview),
    getCompanyInfo(preview),
    getPageContent("palvelumme", preview),
  ]);
  services.forEach((service) => {
    console.log(`Service: ${service.title}`);
    console.log(JSON.stringify(service.content, null, 2));
  });
  return {
    props: {
      services,
      companyInfo,
      pageContent,
      preview,
    },
    //revalidate: siteConfig.revalidate,
  };
}
